/**
 * 生产环境注册 Service Worker，静态资源（含 webfont chunk / woff2）写入 Cache Storage。
 * 请求 persist 存储，降低浏览器清理本地缓存的概率。
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  navigator.serviceWorker.register('/pmsmart-sw.js', { scope: '/' }).catch(() => {});

  if (navigator.storage?.persist) {
    navigator.storage.persist().catch(() => {});
  }
}
